import React, { FormEvent, useState } from 'react';
import { Box, Button, Container, Paper, Stack, TextField, Typography } from '@mui/material';
import { useAppDispatch } from '../../app/hooks';
import { AuthenticateApplicantAsync, setAttemptingLogin } from './authSlice';

const ApplicantLogin = () => {
  const dispatch = useAppDispatch();
  const [code, setCode] = useState<string>('');

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    dispatch(setAttemptingLogin(true));
    dispatch(AuthenticateApplicantAsync(code));
  };

  return (
    <Box>
      <Container maxWidth="sm" sx={{ marginTop: 2 }}>
        <form onSubmit={handleSubmit}>
          <Paper elevation={5}>
            <Stack spacing={2} padding={2}>
              <Typography variant="h4" align="center">
                Enter code
              </Typography>
              <TextField fullWidth label="Code" value={code} onChange={({ target }) => setCode(target.value)} />
              <Button type="submit" variant="contained">
                Submit
              </Button>
            </Stack>
          </Paper>
        </form>
      </Container>
    </Box>
  );
};

export default ApplicantLogin;
